const marketplaceFiltersTemplate = {
  name: "",
  countries: [],
  states: [],
  cities: [],
  available: "all",
  titles: [],
  skills: [],
  minRate: "",
  maxRate: "",
  suitableResources: false,
  excludeResource: "",
};

export default marketplaceFiltersTemplate;